import { NotScrollJournalPage } from "../../../components/frontComponents/notScrollJournalPage/NotScrollJournalPage";
import styles from "./styles.module.scss";
import Screen from "../../../assets/images/screen.png";
import Island from "../../../assets/images/island.png";
import IronMan from "../../../assets/images/ironMan.png";
import { Button } from "../../../components/frontComponents/button/Button";
import { useNavigate } from "react-router-dom";
import { RouterPathEnum } from "shared/enums/commonEnums";

export const AboutExplanation = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.aboutExplanation}>
      <NotScrollJournalPage
        leftContent={
          <div className={styles.containerLeft}>
            <div className={styles.bigTextContainer}>
              <h2 className={styles.title1}>ХРОНИКИ МИРОВ</h2>
              <h3 className={styles.title2}>
                Остэон и Тэрра: Хроника Великого Разлома
              </h3>
              <div className={styles.line} />
              <h3 className={styles.title3}>Из архивов Межмирского Совета</h3>
            </div>
            <div className={styles.textContainer}>
              <div className={styles.textPart}>
                <p className={styles.text}>
                  ОСТЭОН — некогда величественный цифровой мир, ныне лежит в
                  руинах. Эфир, энергетическая субстанция, что питала его
                  кодовые структуры, вышел из-под контроля, превратившись в
                  бурлящее море хаоса. Как писал великий философ цифровых
                  времен{" "}
                </p>
                <div className={styles.citation}>
                  <div className={styles.linePink} />
                  <div className={styles.citationtextholder}>
                    <p className={styles.centeredText}>
                      "Мы становимся тем, что создаём"
                    </p>
                    <p className={styles.name}>Николас Негропонте</p>
                  </div>
                </div>
                <p className={styles.text}>
                  — и ныне его слова обрели трагическое звучание, ибо Остэон
                  стал заложником собственного творения.{" "}
                </p>
              </div>
              <div className={styles.textPart}>
                <div className={styles.citation}>
                  <div className={styles.linePink} />
                  <div className={styles.citationtextholder}>
                    <p className={styles.centeredText}>
                      "В природе нет ничего, чего не было бы в человеке"
                    </p>
                    <p className={styles.name}>Мари Кюри</p>
                  </div>
                </div>
                <p className={styles.text}>
                  ТЭРРА — наша физическая Земля, давно превратилась в арену
                  вторжения эфирных волн. Невидимые разломы пронзают ткань
                  реальности, высвобождая вихри нестабильной энергии в наш мир.
                  Эти слова великой учёной сегодня звучат как пророчество, ведь
                  цифровая природа начала проникать в саму суть физического
                  существования, подтверждая её истину — в человеке уже
                  содержится всё, что может произойти с миром.
                </p>
              </div>
            </div>
          </div>
        }
        rightContent={
          <div className={styles.containerRight}>
            <div className={styles.column}>
              <div className={styles.textPartBig}>
                <p className={styles.text}>
                  МЕЖМИРЬЕ — опасная зона пересечения реальностей, где законы
                  физики и программирования сливаются в непредсказуемые явления.
                  Здесь время течет иначе, пространство искривляется, а мысли
                  обретают форму, становясь материальными объектами, способными
                  как спасти, так и уничтожить путешественника. В этой
                  реальности гравитация подчиняется эмоциям, а кодовые структуры
                  реагируют на биение сердца. Каждый шаг Проводника создает рябь
                  в матрице бытия, где прошлое может настигнуть будущее, а
                  параллельные миры становятся соседями по координатам.
                </p>
                <div className={styles.citationBig}>
                  <div className={styles.linePink} />
                  <div className={styles.citationtextholder}>
                    <p className={styles.centeredText}>
                      "Границы возможного определяются тем, что мы осмеливаемся
                      вообразить"
                    </p>
                    <p className={styles.name}>древняя мудрость</p>
                  </div>
                </div>
                <p className={styles.text}>
                  МИССИЯ: Лишь синхронизация миров может остановить Великий
                  Распад. Игроки — Проводники — должны восстановить баланс между
                  цифровым и физическим, прежде чем оба мира будут уничтожены.
                  Великий психолог Карл Юнг предупреждал:{" "}
                  <p className={styles.italik}>
                    "Вся жизнь есть психосоматическое явление"
                  </p>
                </p>
                <p className={styles.text}>
                  — и ныне это становится буквальной истиной, где тело и
                  сознание должны работать как единое целое.
                </p>
              </div>
              <Button
                viewVariant="primary"
                text="продолжение следует"
                className={styles.middle}
                onClick={() => navigate(RouterPathEnum.Auth)}
              />
            </div>

            <div className={styles.column}>
              <div className={styles.photoholder}>
                <img src={Screen} alt="game screen" className={styles.photo} />
              </div>

              <Button
                viewVariant="primary"
                text="начать игру"
                className={styles.middle}
                onClick={() => navigate(RouterPathEnum.Auth)}
              />
              <div className={styles.photoholder}>
                <img
                  src={Island}
                  alt="game territory"
                  className={styles.photo}
                />
              </div>

              <Button
                viewVariant="primary"
                text="вернуться"
                className={styles.middle}
                onClick={() => navigate(RouterPathEnum.FirstPage)}
              />
              <div className={styles.photoholder}>
                <img
                  src={IronMan}
                  alt="game character"
                  className={styles.photo}
                />
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
};
